const smtImageComponent = {
  edit: {
    container: {
      bgColor: 'theme.500'
    }
  }
};

export default smtImageComponent;
